<template>

  <div class="animated fadeIn">
     <b-row>
       <b-col md="12" sm="12" lg="12">
         <div v-html="help[language]"></div>
       </b-col>
     </b-row>
   </div>

   
</template>

<script>

import InfoService from '@/services/info.service.js';

export default {
  name: 'dashboard',
  data: function () {
    return {
      help: { en: "", iw:""}
    }
  },
  created() {
    InfoService.getHelp().then((res)=>{
      if(res.data.success){
        this.help.en = res.data.help;
        this.help.iw = res.data.help_iw;
      }else{
        alert("ERROR");
      }
    },err => {
      alert("ERROR");
    });
  },
  computed: {
    language() {
        return this.$store.getters['UserModules/getLanguage']
    }
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  .ui-btn-up-c {
    font-family: 'Open Sans', sans-serif;
    border: 1px solid #111;
    background: #669933;
    font-weight: bold;
    color: #000;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#669933), to(#a7c118));
    background-image: linear-gradient(#669933 , #a7c118);
}


</style>

<style type="text/css">
		div.gallery-row:after { clear: both; content: "."; display: block; height: 0; visibility: hidden; }
		div.gallery-item {
	float: left;
	width: 50%;
}
		div.gallery-item a { display: block; margin: 5px; border: 1px solid #3c3c3c; }
		div.gallery-item img { display: block; width: 100%; height: auto; }
		#Gallery1 .ui-content, #Gallery2 .ui-content { overflow: hidden; }
	</style>
	